import SubtleBadge from '@/components/common/SubtleBadge';
import { getColor } from '@/helpers/utils';

// نمایش status code ها در جدول
type StatusCodeRendererProps = {
  statusCode?: number | null;
  /** Theme subtle badge. Solid fill stays the default for crawl tables. */
  subtle?: boolean;
};

const statusBadgeBg = (statusCode: number) => {
  if (statusCode >= 200 && statusCode < 300) return 'success';
  if (statusCode >= 300 && statusCode < 500) return 'warning';
  if (statusCode >= 500) return 'danger';
  return 'secondary';
};

const StatusCodeRenderer = ({
  statusCode,
  subtle = false
}: StatusCodeRendererProps) => {
  const numericStatusCode = Number(statusCode);

  if (subtle) {
    return (
      <SubtleBadge
        bg={
          Number.isFinite(numericStatusCode)
            ? statusBadgeBg(numericStatusCode)
            : 'secondary'
        }
        className="fs--2 fw-bold"
        style={{ lineHeight: 1.2 }}
      >
        {statusCode ?? '—'}
      </SubtleBadge>
    );
  }

  const statusCodeColor = () => {
    if (numericStatusCode >= 200 && numericStatusCode < 300)
      return getColor('success');
    if (numericStatusCode >= 300 && numericStatusCode < 400)
      return getColor('warning');
    if (numericStatusCode >= 400 && numericStatusCode < 500)
      return '#bb881d';
    if (numericStatusCode >= 500) return getColor('danger');
  };
  return (
    <span
      style={{ backgroundColor: statusCodeColor() }}
      className="px-2 h-auto py-1 rounded-2 fs--2 fw-bold text-light"
    >
      {statusCode}
    </span>
  );
};

export default StatusCodeRenderer;
